<template>
	<div class="wrapper">
		<!-- 头部 -->
		<div class="header-wrapper">
			<div class="w">
				<div class="header" :class="{'en': lang == 'en_us'}">
					<div class="menu-wrapper">
						<ul class="menu">
							<li class="menu-item">{{$t(`首页`)}}</li>
							<li class="menu-item" @click="clickDropdown('index-banner')">{{$t(`NFT.PRO卡牌`)}}</li>
							<li class="menu-item" @click="clickDropdown('index-card')">{{$t(`实体卡验真`)}}</li>
							<li class="menu-item" @click="clickDropdown('index-standard')">{{$t(`NFT.PRO行业标准`)}}</li>
						</ul>
					</div>
					<div class="logo">
						<img :src="logoImg" />
					</div>
					<div class="functional-area">
						<div class="login-wrapper" v-if="isAuto" >
							<p>{{$t(`登陆`)}}</p>
							<samp></samp>
							<p>{{$t(`注册`)}}</p>
						</div>
						<div class="logout-wrapper" v-else>
							<p>{{$t(`退出登陆`)}}</p>
						</div>
						<div class="language-wrapper">
							<div class="language" v-if=" lang == 'zh_cn' " @click="languageMenuOpen = !languageMenuOpen" :style="{'background-image':`url(${require(`@/static/images/icon-1.jpg`)}`}"></div>
							<div class="language" v-if=" lang == 'en_us' " @click="languageMenuOpen = !languageMenuOpen" :style="{'background-image':`url(${require(`@/static/images/icon-1.jpg`)}`}"></div>
							<ul class="language-menu" :class="{'language-menu-open': languageMenuOpen == true}">
								<li class="menu-item" @click="language" data-lang="zh_cn">
									{{$t(`简体中文`)}}
								</li>
								<li class="menu-item" @click="language" data-lang="en_us">
									{{$t(`English`)}}
								</li>
							</ul>
						</div>
						<div class="search">
							<div class="input-wrapper">
								<input type="search" name="s" autocomplete="off"/>
							</div>
							<div class="button">
								<span class="iconfont icon-sousuo"></span>
							</div>
						</div>
						
						<div class="menu-h5-wrapper">
							<span class="iconfont icon-menu" @click="phoneMenu = !phoneMenu"></span>
							<div class="menu-h5 scroll-bar" :class="{'menu-expand-item': phoneMenu == true}">
								<ul class="menu">
									<li class="menu-item">{{$t(`首页`)}}</li>
									<li class="menu-item" @click="clickDropdown('index-banner')">{{$t(`NFT.PRO卡牌`)}}</li>
									<li class="menu-item" @click="clickDropdown('index-card')">{{$t(`实体卡验真`)}}</li>
									<li class="menu-item" @click="clickDropdown('index-standard')">{{$t(`NFT.PRO行业标准`)}}</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 幻灯片 -->
		<div class="index-banner">
			<div class="w">
				<div class="upper-wrapper">
					<div class="title" data-scroll-reveal="enter from the top over 0.3s">
						<p>{{$t(`NFT.PRO 卡片`)}}</p>
					</div>
					<div class="explain">
						<p data-scroll-reveal="enter bottom but wait 0.6s">{{$t(`开启未来数字世界的钥匙`)}}</p>
						<p data-scroll-reveal="enter bottom but wait 0.9s">{{$t(`带来全新的数字资产体验和丰富多彩的线下应用场景。`)}}</p>
					</div>
					<div class="button-wrapper">
						<div class="button" data-scroll-reveal="enter bottom but wait 0.6s">{{$t(`发现 NFT.PRO +`)}}</div>
						<div class="button" data-scroll-reveal="enter bottom but wait 0.9s">{{$t(`加入我们 +`)}}</div>
					</div>
				</div>
				
				<div class="swiper below-wrapper">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item, index) in indexBanner">
							<img :src="item.images" />
						</div>
					</div>
					<div class="swiper-pagination"></div>
				</div>
			</div>
		</div>
		
		<!-- 合作伙伴 -->
		<div class="index-partners">
			<div class="w">
				<div class="swiper partners-banner">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item, index) in indexPartners">
							<img :src="item.images"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 关于我们 -->
		<div class="index-about-us">
			<div class="w">
				<div class="content-wrapper">
					<div class="upper-wrapper">
						<div class="title" data-scroll-reveal="enter from the top over 0.6s">
							<p>{{$t(`关于·NFT.PRO`)}}</p>
						</div>
						<div class="button" data-scroll-reveal="enter from the top over 0.9s">{{$t(`参观NFT.PRO +`)}}</div>
					</div>
					<div class="below-wrapper">
						<p data-scroll-reveal="enter right after 0.3s">
							{{$t(`NFT.PRO是全球首个链接数字资产和实体世界资产的认证系统，支持和兼容全球所有主流公链和NFT交易市场的NFT资产。`)}}
						</p>
						<p data-scroll-reveal="enter right after 0.6s">
							{{$t(`NFT.PRO卡片基于全球标准IEEE P3220实现了实体卡片与NFT数字资产的唯一锚定。卡片内置硬件防伪芯片，拥有全球唯一的NID编码。`)}}
						</p>
						<p data-scroll-reveal="enter right after 0.9s">
							{{$t(`NFT.PRO卡片可以绑定用户身份和权益，实现多种数字身份应用，也可以作为数字资产载体不记名转让，充分保证用户的财产安全和隐私。`)}}
						</p>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 卡片 -->
		<div class="index-card">
			<div class="w">
				<div class="content-wrapper">
					<div class="upper-wrapper">
						<div class="item" v-for="(item, index) in indexCard">
							<img class="correct" src="@/static/images/background-1.jpg"/>
							<img class="opposite" src="@/static/images/background-2.jpg"/>
							<div class="content">
								<div class="icon" data-scroll-reveal="enter left after 0.6s">
									<img :src="item.icon" />
								</div>
								<div class="text" data-scroll-reveal="enter left after 0.3s">
									<div class="title"><p>{{item.title}}</p></div>
									<div class="explain scroll-bar"><p>{{item.text}}</p></div>
								</div>
							</div>
						</div>
					</div>
					<div class="below-wrapper">
						<div class="title">
							<p data-scroll-reveal="enter from the top over 0.3s">{{$t(`认识一下`)}}</p>
							<p data-scroll-reveal="enter from the top over 0.6s">{{$t(`NFT.PRO 卡片`)}}</p>
						</div>
						<div class="explain">
							<p data-scroll-reveal="enter from the top over 0.9s">
								{{$t(`NFT.PRO卡片基于全球标准IEEE P3220实现了实体卡片与NFT数字资产的唯一锚定。卡片内置硬件防伪芯片，拥有全球唯一的NID编码。`)}}
							</p>
							<p data-scroll-reveal="enter from the top over 0.1.2s">
								{{$t(`NFT.PRO卡片可以绑定用户身份和权益，实现多种数字身份应用，也可以作为数字资产载体不记名转让，充分保证用户的财产安全和隐私。`)}}
							</p>
						</div>
						<div class="button" data-scroll-reveal="enter from the top over 1.5s">{{$t(`参观NFT.PRO +`)}}</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 行业标准 -->
		<div class="index-standard">
			<div class="w">
				<div class="content-wrapper">
					<div class="upper-wrapper">
						<div class="title">
							<p data-scroll-reveal="enter from the top over 0.3s">{{$t(`NFT.PRO行业标准制定者`)}}</p>
							<p data-scroll-reveal="enter from the top over 0.6s">{{$t(`基于全球标准IEEE P3220`)}}</p>
						</div>
						<div class="images" data-scroll-reveal="enter bottom but wait 0.9s">
							<img src="@/static/images/index-standard-1.png"/>
						</div>
					</div>
					<div class="below-wrapper">
						<div class="item"  v-for="(item, index) in indexStandard">
							<samp class="label">{{item.label}}:</samp>
							<samp class="value">{{item.value}}</samp>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 卡片愿景 -->
		<div class="index-vision">
			<div class="content-wrapper">
				<div class="upper-wrapper">
					<div class="title" data-scroll-reveal="enter from the top over 0.3s">
						<p>{{$t(`NFT.PRO卡片的愿景`)}}</p>
					</div>
					<div class="explain">
						<p data-scroll-reveal="enter from the top over 0.6s">{{$t(`NFT.PRO卡片可以绑定用户身份和权益，实现多种数字身份应用，也可以作为数字资产载体不记名转让，充分保证用户的财产安全和隐私。`)}}</p>
						<p data-scroll-reveal="enter from the top over 0.9s">{{$t(`NFT.PRO卡片将成为开启未来数字世界的钥匙，为全球NFT数字艺术发行平台、NFT创作者、收藏家带来全新的数字资产体验和丰富多彩的线下应用场景。`)}}</p>
					</div>
					<div class="button" data-scroll-reveal="enter from the top over 1.2s">{{$t(`参观NFT.PRO +`)}}</div>
				</div>
				<div class="below-wrapper">
					<div class="images first-image" data-scroll-reveal="enter from the top over 0.3s">
						<img src="@/static/images/index-vision-1.png"/>
					</div>
					<div class="images second-image" data-scroll-reveal="enter bottom but wait 0.6s">
						<img src="@/static/images/index-vision-2.png"/>
					</div>
					<div class="images third-image" data-scroll-reveal="enter from the top over 0.6s">
						<img src="@/static/images/index-vision-3.png"/>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 解决痛点 -->
		<div class="index-resolve">
			<div class="w">
				<div class="upper-wrapper">
					<div class="title">
						<p>{{$t(`NFT.PRO解决痛点`)}}</p>
					</div>
				</div>
				<div class="below-wrapper">
					<div class="item" v-for="(item, index) in indexResolve">
						<div class="content">
							<div class="icon"><img :src="item.icon"/></div>
							<div class="title"><p>{{item.title}}</p></div>
							<div class="explain scroll-bar" v-html="item.text"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 最新卡片 -->
		<div class="index-latest-card">
			<div class="upper-wrapper">
				<div class="title" data-scroll-reveal="enter from the top over 0.3s">
					<p>{{$t(`最新的 NFT.PRO 卡片`)}}</p>
				</div>
				<div class="explain" data-scroll-reveal="enter from the top over 0.6s">
					<p>{{$t(`NFT.PRO卡片可以绑定用户身份和权益，实现多种数字身份应用，也可以作为数字资产载体不记名转让，充分保证用户的财产安全和隐私`)}}</p>
				</div>
			</div>
			<div class="swiper below-wrapper">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item, index) in indexLatestCard" :style="{'background-image':`url(${item.images})`}"></div>
				</div>
				<div class="swiper-pagination"></div>
			</div>
		</div>
		
		<!-- 应用 -->
		<div class="index-apply">
			<div class="w">
				<div class="upper-wrapper">
					<div class="title" data-scroll-reveal="enter from the top over 0.3s">
						<p>{{$t(`NFT.PRO应用`)}}</p>
					</div>
				</div>
				<div class="below-wrapper" data-scroll-reveal="enter bottom but wait 0.6s">
					<div class="swiper main-banner">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item, index) in indexApply">
								<div class="images-wrapper">
									<img src="@/static/images/background-3.jpg"/>
									<div class="images"><img :src="item.images"/></div>
								</div>
								<div class="content-wrapper">
									<div class="title"><p>{{item.title}}</p></div>
									<div class="explain"><p>{{item.text}}</p></div>
								</div>
							</div>
						</div>
						<div class="swiper-button-next"></div>
					</div>
					<div class="swiper thumbnails-banner">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item, index) in indexApply">
								<p>{{item.title}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 加入我们 -->
		<div class="index-join-us">
			<div class="w">
				<div class="upper-wrapper">
					<div class="title" data-scroll-reveal="enter from the top over 0.3s">
						<p>{{$t(`即刻加入 CK NFT.PRO`)}}</p>
					</div>
					<div class="explain" data-scroll-reveal="enter from the top over 0.6s">
						<p>{{$t(`NFT.PRO全球合作伙伴招募现已正式启动，邀您共同迎接数字资产领域前所未有的创新浪潮！`)}}</p>
					</div>
				</div>
				<div class="below-wrapper">
					<div class="form-wrapper" data-scroll-reveal="enter from the top over 0.9s">
						<div class="input-wrapper">
							<input type="text" name="email" :placeholder="$t(`请填写您的邮箱，我们将尽快回复您`)" autocomplete="off"/>
						</div>
						<div class="button">{{$t(`提交信息`)}}</div>
					</div>
					<div class="text" data-scroll-reveal="enter from the top over 1.2s">{{$t(`或者向`)}}<samp>business@nft.pro</samp>{{$t(`邮箱提交您的信息`)}}</div>
				</div>
			</div>
		</div>
		
		<!-- 底部 -->
		<div class="footer-wrapper">
			<div class="w">
				<div class="content-wrapper">
					<div class="logo-wrapper">
						<div class="logo">
							<img :src="logoImg" />
						</div>
						<div class="button">
							<samp class="icon"></samp>
							<p>business@nft.pro</p>
						</div>
					</div>
					<div class="menu-wrapper">
						<ul class="menu">
							<li class="menu-item" v-for="(item, index) in footerMenu" >{{item.name}}</li>
						</ul>
					</div>
					<div class="follow-us-wrapper">
						<div class="follow-us">
							<a :style="{'background-image':`url(${require(`@/static/images/icon-13.png`)}`}"></a>
							<a :style="{'background-image':`url(${require(`@/static/images/icon-14.png`)}`}"></a>
							<a :style="{'background-image':`url(${require(`@/static/images/icon-15.png`)}`}"></a>
							<a :style="{'background-image':`url(${require(`@/static/images/icon-16.png`)}`}"></a>
							<a :style="{'background-image':`url(${require(`@/static/images/icon-17.png`)}`}"></a>
						</div>
						<div class="text">@2023 YOULINK</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper/swiper-bundle';
	export default {
		data() {
			return {
				isAuto: true,
				rangeArr: [],
				lang: 'zh_cn',
				phoneMenu: false,
				languageMenuOpen: false,
				logoImg: require('@/static/images/logo-1.png'),
				// 幻灯片
				indexBanner: [
					{ images: require('@/static/images/banner-1.jpg') },
					{ images: require('@/static/images/banner-2.jpg') },
					{ images: require('@/static/images/banner-3.jpg') },
					{ images: require('@/static/images/banner-4.jpg') },
					{ images: require('@/static/images/banner-5.jpg') },
					{ images: require('@/static/images/banner-6.jpg') },
					{ images: require('@/static/images/banner-7.jpg') },
					{ images: require('@/static/images/banner-8.jpg') },
					{ images: require('@/static/images/banner-9.jpg') },
					{ images: require('@/static/images/banner-10.jpg') },
				],
				
				// 合作伙伴
				indexPartners: [
					{ images: require('@/static/images/index-partners-banner-1.jpg') },
					{ images: require('@/static/images/index-partners-banner-2.jpg') },
					{ images: require('@/static/images/index-partners-banner-3.jpg') },
					{ images: require('@/static/images/index-partners-banner-4.jpg') },
					{ images: require('@/static/images/index-partners-banner-5.jpg') },
					{ images: require('@/static/images/index-partners-banner-6.jpg') }
				],
				
				// 卡片
				indexCard: [{
					title: this.$t(`造物-内容共创`),
					icon : require('@/static/images/icon-3.png'),
					text : this.$t(`将NFT用实体卡牌形式呈现,内容与功能专属定制,全球数字藏品发行平台、收藏者和创作者带来全新的数字资产体验。`)
				}, {
					title: this.$t(`造场-体验共创`),
					icon : require('@/static/images/icon-4.png'),
					text : this.$t(`全球首发NFT实体卡牌,率先打通数字资产的线上线下权益，数字资产和实物呈现的完美融合。`)
				}, {
					title: this.$t(`造生态-IP共创`),
					icon : require('@/static/images/icon-5.png'),
					text : this.$t(`版权+，全球资产认证系统；AI+,内容生态智能化生成；盲盒+，年轻化社交思路。让价值最大化，内容多元化，传播趣味化`)
				}],
				
				// 行业标准
				indexStandard: [{
					label: this.$t(`内核标准`),
					value: this.$t(`卡牌内核制作支持的标准`)
				}, {
					label: this.$t(`算法标准`),
					value: this.$t(`支持 Single DES、Triple DES 算法：可自动根据密钥的长度选择Single DES、Triple DES算法`)
				}, {
					label: this.$t(`加密标准`),
					value: this.$t(`支持线路加密、线路保护功能：防止通信数据被非法窃取或篡改`)
				}, {
					label: this.$t(`应用标准`),
					value: this.$t(`支持在一张卡上实现多个不同的应用：可建立三级目录`)
				}, {
					label: this.$t(`电子钱包`),
					value: this.$t(`支持电子钱包功能：钱包大小可由用户自行设定`)
				}, {
					label: this.$t(`文件类型`),
					value: this.$t(`支持多种文件类型：包括二进制文件、定长记录文件、变长记录文件、循环文件、钱包文件`)
				}, {
					label: this.$t(`ISO系列规范`),
					value: this.$t(`ISO14443-4：T=CL 通讯协议`)
				}],
				
				// 解决痛点
				indexResolve: [{
					title: this.$t(`开创数字藏品行业新形态`),
					icon : require('@/static/images/icon-6.png'),
					text : this.$t(`解决了传统数字藏品、数字资产与线下脱节的状态`)
				}, {
					title: this.$t(`重塑资产流通性`),
					icon : require('@/static/images/icon-7.png'),
					text : this.$t(`数字资产与实物卡片结合相关作品上链数字资产专卖过程中享受分成收益激发数字领域创作生态，实现资产有效流通价值最大化`)
				}, {
					title: this.$t(`版权保护`),
					icon : require('@/static/images/icon-8.png'),
					text : this.$t(`NFT的唯一性和不可篡改的特性使得NFT.PRO实体卡牌继承这项优点可以用来标记数字内容的所有权可以实现IP价值的流动性，这对于数字艺术品的转卖和分成收益具有重要意义`)
				}, {
					title: this.$t(`法规监管`),
					icon : require('@/static/images/icon-9.png'),
					text : this.$t(`传统数字藏品缺乏健全的法规和监管NFT. PRO是全球首个链接数字资产和实体世界资产的认证系统，支持和兼容全球所有主流公链和NFT交易市场的NFT资产。提供卡牌验真服务`)
				}, {
					title: this.$t(`技术安全`),
					icon : require('@/static/images/icon-10.png'),
					text : this.$t(`传统数字藏品是以数字形式存在的，因此面临着技术安全方面的挑战，如黑客攻击、密码被盗等问题，可能导致藏品的丢失或被盗NFT.PRO卡片内置硬件防伪芯片，拥有全球唯一的NID编码。`)
				}, {
					title: this.$t(`认证标准`),
					icon : require('@/static/images/icon-11.png'),
					text : this.$t(`传统数字藏品的认证和鉴定缺乏统一的标准，可能导致市场上的假冒伪劣产品泛滥，影响消费者的信心。NFT.PRO基于全球标准IEEE P3220行业标准，实现了实体卡片与NFT数字资产的唯一锚定`)
				}],
				
				// 最新卡片
				indexLatestCard: [
					{ images: require('@/static/images/banner-1.jpg') },
					{ images: require('@/static/images/banner-2.jpg') },
					{ images: require('@/static/images/banner-3.jpg') },
					{ images: require('@/static/images/banner-4.jpg') },
					{ images: require('@/static/images/banner-5.jpg') },
					{ images: require('@/static/images/banner-6.jpg') },
					{ images: require('@/static/images/banner-7.jpg') },
					{ images: require('@/static/images/banner-8.jpg') },
					{ images: require('@/static/images/banner-9.jpg') },
					{ images: require('@/static/images/banner-10.jpg') },
				],
				
				// 应用
				indexApply: [{
					title: this.$t(`实体门店销售`),
					images: require('@/static/images/index-apply-1.jpg'),
					text: this.$t(`NFT.PRO加盟店、零售店橱窗柜台、餐饮店橱窗柜台、娱乐场所橱窗柜台（电影院、KTV、健身中心）、医疗美容美发橱窗柜台、交通工具（可刷卡的全部交通工具）`)
				},{
					title: this.$t(`商业品牌营销`),
					images: require('@/static/images/index-apply-1.jpg'),
					text: this.$t(`NFT.PRO加盟店、零售店橱窗柜台、餐饮店橱窗柜台、娱乐场所橱窗柜台（电影院、KTV、健身中心）、医疗美容美发橱窗柜台、交通工具（可刷卡的全部交通工具）`)
				},{
					title: this.$t(`数字艺术品收藏`),
					images: require('@/static/images/index-apply-1.jpg'),
					text: this.$t(`NFT.PRO加盟店、零售店橱窗柜台、餐饮店橱窗柜台、娱乐场所橱窗柜台（电影院、KTV、健身中心）、医疗美容美发橱窗柜台、交通工具（可刷卡的全部交通工具）`)
				},{
					title: this.$t(`数字资产装备`),
					images: require('@/static/images/index-apply-1.jpg'),
					text: this.$t(`NFT.PRO加盟店、零售店橱窗柜台、餐饮店橱窗柜台、娱乐场所橱窗柜台（电影院、KTV、健身中心）、医疗美容美发橱窗柜台、交通工具（可刷卡的全部交通工具）`)
				},{
					title: this.$t(`身份象征`),
					images: require('@/static/images/index-apply-1.jpg'),
					text: this.$t(`NFT.PRO加盟店、零售店橱窗柜台、餐饮店橱窗柜台、娱乐场所橱窗柜台（电影院、KTV、健身中心）、医疗美容美发橱窗柜台、交通工具（可刷卡的全部交通工具）`)
				}],
				
				// 底部菜单
				footerMenu: [
					{ url: '', name: this.$t(`关于我们`) },
					{ url: '', name: this.$t(`NFT.PRO 卡片`) },
					{ url: '', name: this.$t(`我们的愿景`) },
					{ url: '', name: this.$t(`加入我们`) },
					{ url: '', name: this.$t(`联系我们`) },
				]
			}
		},
		mounted(){
			let that = this;
			
			// 延时加载
			setTimeout(() =>{
				'use strict';
				window.scrollReveal = new scrollReveal({ reset: false, move: '50px' });
			}, 100);
			
			// 监听滚动
			window.addEventListener('scroll', this.handleScroll);
			
			// 监听宽度
			window.onresize = () => {
				return (() => {
					// 设置最新卡片总高度
					that.latestCardHeight();
				})()
			}
			
			// 幻灯片
			that.banner();
			
			// 动态显示
			that.dynamicDisplay();
			
			// 设置最新卡片总高度
			that.latestCardHeight();
			
			// 悬停动画
			var hoverClassArr = [
				'.index-banner .upper-wrapper .button-wrapper .button',
				'.index-latest-card .below-wrapper .swiper-wrapper .swiper-slide',
				'.footer-wrapper .content-wrapper .menu-wrapper .menu .menu-item'
			];
			hoverClassArr.map(function(index){
				$(index).on({
					mouseover: function () {
						$(this).addClass('current-hover-item');
					},
					mouseout: function (){
						$(this).removeClass('current-hover-item')
					}
				})
			});
			
			// 当前语言
			that.lang = that.$cookie.get('ck-language') != undefined? that.$cookie.get('ck-language'): 'zh_cn';
		},
		methods: {
			/**
			 * 语言切换
			 * @param {Object} e
			 */
			language(e) {
				let language = e.currentTarget.dataset.lang;
				this.$cookie.set('ck-language', language);
				this.$router.go(0);
			},
			
			/**
			 * 监听滚动
			 */
			handleScroll() {
				// 卡片翻转
				this.cardOverturn();
			},
			
			/**
			 * 卡片翻转
			 */
			cardOverturn() {
				$('.index-card .content-wrapper .upper-wrapper .item').each(function(){
					var elementHeight = parseInt($(this).outerHeight(), 10);
					var elementBottom = parseInt((parseInt(($(this).offset().top - $(window).scrollTop()), 10) - window.innerHeight), 10);
					if( parseInt((elementBottom + (elementHeight / 2)), 10) <= 0 ){
						$(this).find(".correct").addClass("opposite-hover-item");
						$(this).find(".opposite").addClass('correct-hover-item');
					}
				});
			},
			
			/**
			 * 设置最新卡片总高度
			 */
			latestCardHeight() {
				$('.index-latest-card .below-wrapper .swiper-wrapper').css({
					height: parseInt((($(window).width() * 0.15555) * 2), 10) + 'px'
				})
			},
			
			/**
			 * 点击下拉
			 * @param {Object} index
			 */
			clickDropdown(index){
				this.phoneMenu = false;
				var elementTop = parseInt($('.' + index).offset().top, 10);
				$("html, body").animate({ 
					scrollTop: elementTop 
				}, "slow");
			},
			
			/**
			 * 幻灯片
			 */
			banner() {
				// 主图-幻灯片
				var indexBanner =  new Swiper(".index-banner .below-wrapper", {
					loop: true,
					grabCursor : true,
					effect: 'coverflow',
					centeredSlides: true,
					slidesPerView: 'auto',
					coverflowEffect: {
						rotate: 0,
						depth: 30,
						modifier: 1,
						stretch: 240,
						slideShadows: false,
					},
					pagination: {
						el: '.index-banner .below-wrapper .swiper-pagination',
					},
				});
				
				// 合作伙伴-幻灯片
				var indexPartnersBanner =  new Swiper(".index-partners .partners-banner", {
					loop: true,
					freeMode: true,
					slidesPerView: 6,
					spaceBetween: 50,
					on: {
						init: function(){
							// 边距
							if ( document.body.clientWidth >= 1441 && document.body.clientWidth <= 1680 ){
								this.params.spaceBetween = 40;
							} else if ( document.body.clientWidth >= 1281 && document.body.clientWidth <= 1440 ){
								this.params.spaceBetween = 30;
							} else if ( document.body.clientWidth >= 1001 && document.body.clientWidth <= 1280 ){
								this.params.spaceBetween = 20;
							} else if ( document.body.clientWidth >= 751 && document.body.clientWidth <= 1000 ){
								this.params.spaceBetween = 10;
							} else if ( document.body.clientWidth <= 750 ){
								this.params.spaceBetween = 0;
							}else{
								this.params.spaceBetween = 50;
							}
							this.update();
						}, 
						resize: function() {
							// 边距
							if ( document.body.clientWidth >= 1441 && document.body.clientWidth <= 1680 ){
								this.params.spaceBetween = 40;
							} else if ( document.body.clientWidth >= 1281 && document.body.clientWidth <= 1440 ){
								this.params.spaceBetween = 30;
							} else if ( document.body.clientWidth >= 1001 && document.body.clientWidth <= 1280 ){
								this.params.spaceBetween = 20;
							} else if ( document.body.clientWidth >= 751 && document.body.clientWidth <= 1000 ){
								this.params.spaceBetween = 10;
							} else if ( document.body.clientWidth <= 750 ){
								this.params.spaceBetween = 0;
							}else{
								this.params.spaceBetween = 50;
							}
							this.update();
						},
					}
				});
				
				// 最新卡片-幻灯片
				var indexLatestCardBanner =  new Swiper(".index-latest-card .below-wrapper", {
					loop: true,
					spaceBetween: 35,
					slidesPerView: 'auto',
					pagination: {
						el: '.index-latest-card .below-wrapper .swiper-pagination',
					},
					on: {
						init: function(){
							// 边距
							if ( document.body.clientWidth >= 1441 && document.body.clientWidth <= 1680 ){
								this.params.spaceBetween = 30;
							} else if ( document.body.clientWidth >= 1281 && document.body.clientWidth <= 1440 ){
								this.params.spaceBetween = 25;
							} else if ( document.body.clientWidth >= 1001 && document.body.clientWidth <= 1280 ){
								this.params.spaceBetween = 20;
							} else if ( document.body.clientWidth >= 751 && document.body.clientWidth <= 1000 ){
								this.params.spaceBetween = 15;
							} else if ( document.body.clientWidth <= 750 ){
								this.params.spaceBetween = 10;
							}else{
								this.params.spaceBetween = 35;
							}
							this.update();
						}, 
						resize: function() {
							// 边距
							if ( document.body.clientWidth >= 1441 && document.body.clientWidth <= 1680 ){
								this.params.spaceBetween = 30;
							} else if ( document.body.clientWidth >= 1281 && document.body.clientWidth <= 1440 ){
								this.params.spaceBetween = 25;
							} else if ( document.body.clientWidth >= 1001 && document.body.clientWidth <= 1280 ){
								this.params.spaceBetween = 20;
							} else if ( document.body.clientWidth >= 751 && document.body.clientWidth <= 1000 ){
								this.params.spaceBetween = 15;
							} else if ( document.body.clientWidth <= 750 ){
								this.params.spaceBetween = 10;
							}else{
								this.params.spaceBetween = 35;
							}
							this.update();
						},
					}
				});
				
				// 应用-缩略-幻灯片
				var indexApplyThumbnailsBanner =  new Swiper(".index-apply .thumbnails-banner", {
					slidesPerView: 5,
					on: {
						init: function(){
							// 边距
							if ( document.body.clientWidth >= 751 && document.body.clientWidth <= 1000 ){
								this.params.slidesPerView = 4;
							} else if ( document.body.clientWidth <= 750 ){
								this.params.slidesPerView = 3;
							}else{
								this.params.slidesPerView = 5;
							}
							this.update();
						}, 
						resize: function() {
							// 边距
							if ( document.body.clientWidth >= 751 && document.body.clientWidth <= 1000 ){
								this.params.slidesPerView = 4;
							} else if ( document.body.clientWidth <= 750 ){
								this.params.slidesPerView = 3;
							}else{
								this.params.slidesPerView = 5;
							}
							this.update();
						},
					}
				});
				
				// 应用-主要-幻灯片
				var indexApplyMainBanner =  new Swiper(".index-apply .main-banner", {
					navigation: {
						nextEl: ".index-apply .main-banner .swiper-button-next"
					},
					thumbs: {
						swiper: indexApplyThumbnailsBanner
					}
				});
			},
			
			/**
			 * 动态显示
			 */
			dynamicDisplay(){
				// 递增数组，用于动态显示时间
				var rangeArr = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20];
				
				// 行业标准
				$('.index-standard .content-wrapper .below-wrapper .item').each(function(index){
					$(this).attr('data-scroll-reveal', 'enter from the top over ' + (rangeArr[index % 8] / 10) + 's')
				});
				
				// 最新卡片
				$('.index-resolve .below-wrapper .item').each(function(index){
					$(this).attr('data-scroll-reveal', 'enter bottom but wait ' + (rangeArr[index % 3] / 10) + 's')
				});
			}
		}
	}
</script>